var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSubmittedFormDecorativeImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 96,
    viewBox: "0 0 113 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.097 47.9394C104.097 74.4156 82.6334 95.8788 56.1572 95.8788C29.681 95.8788 8.21777 74.4156 8.21777 47.9394C8.21777 21.4632 29.681 0 56.1572 0C82.6334 0 104.097 21.4632 104.097 47.9394Z",
    fill: "#F2F6FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7643 35.2712C34.9411 33.981 30.6731 28.4195 29.8839 29.9226C29.4744 30.6963 34.7633 40.5762 35.1634 42.013C36.9733 40.8254 39.0361 40.0725 41.1888 39.8136C40.4646 38.41 40.5757 36.5643 37.7643 35.2712Z",
    fill: "#877BD4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1605 58.8228C26.4289 58.725 25.6852 58.77 24.9709 58.9554C21.9477 59.6622 15.4128 57.8613 15.4573 59.5522C15.4906 60.6679 26.9938 65.2109 27.4606 65.6745C28.0782 63.7288 29.1178 61.9417 30.5061 60.4393C29.4741 59.9612 28.6388 59.0549 27.1605 58.8228Z",
    fill: "#877BD4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0473 77.6217C95.1467 78.1202 95.095 78.6367 94.8988 79.1059C94.7026 79.5751 94.3707 79.9759 93.9452 80.2573C93.5199 80.5387 93.0202 80.6885 92.5093 80.6878C91.9984 80.687 91.4992 80.5359 91.0747 80.2533C90.7218 80.0181 90.4327 79.7 90.233 79.3271C90.0333 78.9543 89.9291 78.5383 89.9297 78.1159C89.9303 77.6935 90.0356 77.2777 90.2364 76.9054C90.4372 76.5332 90.7272 76.2159 91.0808 75.9817C91.4343 75.7475 91.8405 75.6036 92.2633 75.5628C92.6861 75.522 93.1126 75.5855 93.5048 75.7476C93.8971 75.9098 94.243 76.1657 94.5121 76.4926C94.7812 76.8195 94.965 77.2073 95.0473 77.6217Z",
    fill: "#877BD4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3407 27.8003C80.1757 22.1748 84.366 23.28 86.6001 30.7402C85.7109 26.9604 91.2484 22.3848 91.6438 44.0893C91.4391 44.1812 91.2601 44.3208 91.1214 44.4965C89.79 41.3263 87.25 43.2441 87.5981 45.8344C87.6443 46.1811 87.3916 46.3643 86.8651 45.7925C86.3134 45.1788 85.6705 45.5191 85.6097 46.1799L84.1513 46.3567C82.0251 44.2452 80.3044 41.7656 79.0736 39.0397C76.595 33.8784 77.9955 27.8882 82.1858 36.3761C81.0351 33.658 80.4091 30.7487 80.3407 27.8003Z",
    fill: "#877BD4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6093 47.8477C86.8357 48.5806 86.9369 49.3467 86.9088 50.1133C86.8029 49.2088 86.3712 48.5719 85.709 47.8762L86.6093 47.8477Z",
    fill: "#6153BD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6847 31.7328C71.4958 31.3256 71.2168 30.773 70.9512 30.2646C71.8064 30.374 72.0515 30.9481 71.6847 31.7328Z",
    fill: "#6153BD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9397 51.6825C67.1061 52.0362 66.8727 53.5945 67.1839 55.7718L72.1077 54.9539C70.8067 53.0419 69.0845 51.2183 67.9397 51.6825Z",
    fill: "#6153BD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9082 69.5215C76.7192 70.6046 76.1412 71.2788 75.0742 70.8146C75.6855 70.3934 76.2968 69.9624 76.9082 69.5215Z",
    fill: "#6153BD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1721 35.5475C64.1606 35.4923 63.8266 34.8734 64.3157 33.9561C64.5713 34.5017 64.8568 35.0333 65.1721 35.5475Z",
    fill: "#6153BD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.878 53.8382C87.878 53.9628 87.8282 54.0824 87.7395 54.1705C87.6509 54.2587 87.5306 54.3082 87.4053 54.3082C87.2799 54.3082 87.1597 54.2587 87.0711 54.1705C86.9824 54.0824 86.9326 53.9628 86.9326 53.8382C86.9326 53.7135 86.9824 53.594 87.0711 53.5058C87.1597 53.4177 87.2799 53.3682 87.4053 53.3682C87.5306 53.3682 87.6509 53.4177 87.7395 53.5058C87.8282 53.594 87.878 53.7135 87.878 53.8382Z",
    fill: "#6153BD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6469 51.2291C95.6375 51.3472 95.5837 51.4576 95.4962 51.5381C95.4086 51.6185 95.2938 51.6632 95.1745 51.6632C95.0553 51.6632 94.9404 51.6185 94.8529 51.5381C94.7653 51.4576 94.7115 51.3472 94.7021 51.2291C94.7095 51.1094 94.7624 50.9971 94.8502 50.915C94.938 50.8328 95.054 50.7871 95.1745 50.7871C95.2951 50.7871 95.411 50.8328 95.4988 50.915C95.5866 50.9971 95.6396 51.1094 95.6469 51.2291Z",
    fill: "#6153BD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7365 42.8525C98.7365 42.9157 98.7237 42.9782 98.6989 43.0364C98.674 43.0946 98.6377 43.1471 98.592 43.191C98.5462 43.2349 98.4921 43.2692 98.4328 43.2918C98.3734 43.3144 98.3101 43.3249 98.2466 43.3227C98.1831 43.3205 98.1207 43.3056 98.0631 43.2788C98.0055 43.2521 97.954 43.2141 97.9115 43.1672C97.869 43.1202 97.8364 43.0652 97.8157 43.0054C97.7951 42.9457 97.7867 42.8824 97.7912 42.8194C97.7998 42.6977 97.8556 42.5841 97.9468 42.5026C98.038 42.421 98.1574 42.3778 98.28 42.3821C98.4025 42.3864 98.5186 42.4379 98.6038 42.5256C98.689 42.6134 98.7366 42.7306 98.7365 42.8525Z",
    fill: "#6153BD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M106.049 38.6529C106.042 38.7725 105.989 38.8848 105.901 38.967C105.813 39.0491 105.697 39.0948 105.577 39.0948C105.456 39.0948 105.34 39.0491 105.253 38.967C105.165 38.8848 105.112 38.7725 105.104 38.6529C105.112 38.5333 105.165 38.4209 105.253 38.3388C105.34 38.2567 105.456 38.2109 105.577 38.2109C105.697 38.2109 105.813 38.2567 105.901 38.3388C105.989 38.4209 106.042 38.5333 106.049 38.6529Z",
    fill: "#6153BD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9555 61.6734C85.951 61.7952 85.8992 61.9104 85.8111 61.995C85.723 62.0796 85.6053 62.1269 85.4828 62.1272C85.3605 62.1266 85.2431 62.0792 85.1551 61.9946C85.0671 61.9101 85.0154 61.795 85.0107 61.6734C85.0153 61.5518 85.067 61.4367 85.155 61.3521C85.243 61.2675 85.3604 61.2201 85.4828 61.2197C85.6052 61.2202 85.7227 61.2677 85.8108 61.3522C85.8988 61.4368 85.9507 61.5518 85.9555 61.6734Z",
    fill: "#6153BD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6303 58.8443C77.6258 58.9661 77.574 59.0813 77.4859 59.1659C77.3978 59.2505 77.2801 59.2978 77.1576 59.2981C77.0353 59.2975 76.9179 59.2501 76.8299 59.1655C76.7419 59.081 76.6902 58.9659 76.6855 58.8443C76.6901 58.7227 76.7418 58.6076 76.8298 58.523C76.9178 58.4384 77.0353 58.391 77.1576 58.3906C77.28 58.3911 77.3975 58.4386 77.4856 58.5231C77.5736 58.6077 77.6255 58.7227 77.6303 58.8443Z",
    fill: "#6153BD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0981 50.6753C80.0907 50.795 80.0378 50.9073 79.95 50.9894C79.8622 51.0716 79.7462 51.1173 79.6257 51.1173C79.5052 51.1173 79.3892 51.0716 79.3014 50.9894C79.2136 50.9073 79.1607 50.795 79.1533 50.6753C79.1607 50.5557 79.2136 50.4434 79.3014 50.3613C79.3892 50.2791 79.5052 50.2334 79.6257 50.2334C79.7462 50.2334 79.8622 50.2791 79.95 50.3613C80.0378 50.4434 80.0907 50.5557 80.0981 50.6753Z",
    fill: "#6153BD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9311 42.1451C77.9217 42.2633 77.8679 42.3736 77.7803 42.4541C77.6928 42.5345 77.5779 42.5792 77.4587 42.5792C77.3395 42.5792 77.2246 42.5345 77.1371 42.4541C77.0495 42.3736 76.9957 42.2633 76.9863 42.1451C76.9937 42.0254 77.0466 41.9131 77.1344 41.831C77.2222 41.7489 77.3382 41.7031 77.4587 41.7031C77.5792 41.7031 77.6952 41.7489 77.783 41.831C77.8708 41.9131 77.9238 42.0254 77.9311 42.1451Z",
    fill: "#6153BD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8393 38.6529C68.832 38.7725 68.779 38.8848 68.6912 38.967C68.6034 39.0491 68.4874 39.0948 68.3669 39.0948C68.2464 39.0948 68.1304 39.0491 68.0426 38.967C67.9548 38.8848 67.9019 38.7725 67.8945 38.6529C67.9019 38.5333 67.9548 38.4209 68.0426 38.3388C68.1304 38.2567 68.2464 38.2109 68.3669 38.2109C68.4874 38.2109 68.6034 38.2567 68.6912 38.3388C68.779 38.4209 68.832 38.5333 68.8393 38.6529Z",
    fill: "#6153BD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8523 51.6113H73.1406L77.631 55.9048L74.8523 51.6113Z",
    fill: "#6153BD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4113 50.6992C88.9921 50.5882 88.5888 50.4248 88.2109 50.2129L89.3446 51.7049C89.3147 51.3683 89.3372 51.029 89.4113 50.6992Z",
    fill: "#6153BD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6783 53.4844C90.0819 55.5261 89.735 57.644 88.7002 59.4525L90.2563 58.0931C90.4628 56.533 90.2638 54.9463 89.6783 53.4844Z",
    fill: "#6153BD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3844 71.0126C28.7341 71.2664 25.077 70.6245 21.7347 69.1433C18.3924 67.6621 15.4673 65.3871 13.2166 62.5182C10.9659 59.6493 9.45857 56.2744 8.82718 52.6904C8.19579 49.1065 8.45967 45.4231 9.5956 41.9643C10.5398 39.0847 12.0664 36.4277 14.0814 34.1564C16.0965 31.8852 18.5575 30.0479 21.3131 28.7574C24.0687 27.4669 27.0607 26.7505 30.105 26.6523C33.1494 26.5541 36.1817 27.0761 39.0156 28.1863C41.8496 29.2965 44.4252 30.9714 46.5841 33.108C48.7429 35.2446 50.4395 37.7977 51.5694 40.6103C52.6993 43.423 53.2386 46.4357 53.1543 49.4633C53.0699 52.4909 52.3636 55.4693 51.0788 58.2155",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M91.646 44.0905C91.2459 22.3848 85.7113 26.9604 86.6005 30.7402C84.3665 23.28 80.1774 22.1748 80.3412 27.8003C80.4102 30.7487 81.0361 33.6578 82.1862 36.3761C77.9959 27.8887 76.5966 33.8778 79.0741 39.0397C80.3011 41.7593 82.0164 44.2338 84.136 46.3416M86.9094 50.1133C86.8035 49.2064 86.3689 48.5695 85.7043 47.8714",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2301 53.2188C33.9624 55.175 30.4501 57.1422 27.1602 58.8221",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2573 33.8343C54.4263 31.1382 59.518 30.3523 60.5611 32.1434C61.9305 34.4963 55.8929 40.6645 46.0791 47.5167",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19.992 62.2599C9.97757 66.7132 2.42011 68.4839 1.11968 66.2491C0.0637775 64.4365 3.40932 60.3478 9.51074 55.4297",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M73.141 51.6108L77.6314 55.9043L64.2275 35.1602",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2119 50.2131C88.2119 50.2131 91.8131 52.3682 91.7909 48.0911C91.7597 46.9266 91.6049 44.9661 91.2344 44.5977",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2119 50.2129L89.3462 51.6799",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2345 44.5973C89.9622 41.5144 87.2019 43.168 87.595 45.8775C87.6336 46.1444 87.4195 46.401 86.8673 45.7925C86.3209 45.1876 85.6821 45.5203 85.6143 46.1712L86.6034 47.8208M85.8003 50.268C86.5339 51.0085 87.4036 51.0038 86.6034 47.8208M86.6034 47.8208C86.5658 47.7939 86.5371 47.7932 86.5005 47.765",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M71.751 30.6963C74.897 36.0519 82.2726 47.9369 87.345 51.6056C87.6259 51.8377 87.9562 52.0031 88.311 52.0892C88.6658 52.1754 89.0356 52.1801 89.3925 52.1029C89.3208 51.6334 89.3283 51.1553 89.4147 50.6883",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M90.168 58.1786C90.7794 56.2334 89.679 53.4814 89.679 53.4814C89.679 53.4814 92.2875 61.8426 76.498 70.6587",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8518 51.6113H68.5977",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7002 59.4521C88.7002 59.4521 99.8817 50.2033 107.639 37.7133C106.663 36.0439 105.111 34.7832 103.272 34.165C100.819 37.6827 98.1624 41.0556 95.3158 44.2666",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9902 70.8795C78.1351 72.2476 77.0933 65.301 74.9902 60.3264C73.8033 57.5186 70.095 50.7565 67.9774 51.9768C67.2251 52.4102 67.0233 53.9284 67.3216 56.0161",
    fill: "url(#paint0_linear_412_373)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9902 70.8795C78.1351 72.2476 77.0933 65.301 74.9902 60.3264C73.8033 57.5186 70.095 50.7565 67.9774 51.9768C67.2251 52.4102 67.0233 53.9284 67.3216 56.0161",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2697 65.1155L31.6471 60.96C29.5454 62.8425 28.0949 65.2828 27.4863 67.9601C34.4289 73.0918 41.85 77.6159 49.6579 81.4765C50.588 81.9462 51.6179 82.2118 52.6712 82.2537C53.7245 82.2957 54.7743 82.1128 55.7427 81.7187C63.3693 78.6706 70.6211 74.8433 77.3692 70.3049",
    fill: "url(#paint1_linear_412_373)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2697 65.1155L31.6471 60.96C29.5454 62.8425 28.0949 65.2828 27.4863 67.9601C34.4289 73.0918 41.85 77.6159 49.6579 81.4765C50.588 81.9462 51.6179 82.2118 52.6712 82.2537C53.7245 82.2957 54.7743 82.1128 55.7427 81.7187C63.3693 78.6706 70.6211 74.8433 77.3692 70.3049",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1868 39.8133C39.0341 40.072 36.9713 40.825 35.1615 42.0127C34.7613 40.5759 29.4725 30.6965 29.882 29.9223C30.6752 28.421 34.9398 33.9761 37.7623 35.2738C40.5767 36.5623 40.4644 38.4097 41.1868 39.8133Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1605 58.8218C26.4289 58.724 25.6852 58.769 24.9709 58.9545C21.9477 59.6612 15.4128 57.8603 15.4573 59.5513C15.4906 60.6669 26.9938 65.2099 27.4606 65.6735C28.0782 63.7279 29.1178 61.9407 30.5061 60.4383C29.4741 59.9602 28.6388 59.0539 27.1605 58.8218Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5728 24.4622C66.5728 24.4622 66.5728 23.147 66.5616 21.1024C66.5499 18.9583 67.3865 18.5476 67.7065 20.9808C67.741 21.2461 68.1511 23.9096 68.2733 24.6943C68.34 25.1253 68.6506 26.3155 69.0514 26.2649C70.1505 26.1223 72.222 23.731 72.8742 24.4413C73.2989 24.9066 72.0208 26.5865 71.0737 27.7237C70.8067 28.0432 70.641 28.4343 70.5976 28.8474C70.5542 29.2605 70.635 29.6772 70.8297 30.0447C70.8625 30.1098 71.6265 31.6379 71.6856 31.7315",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7379 25.0047C66.7379 25.0047 65.3158 20.5286 65.2263 20.2302C64.5208 17.8854 63.7673 18.4183 64.1148 20.5286C64.4459 22.5407 64.8168 24.9937 64.8168 24.9937",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1716 25.7208C64.4831 24.3582 63.8776 22.9558 63.3581 21.521C62.5111 19.2234 61.8775 19.7975 62.2689 21.9078C62.4819 23.2117 62.7948 24.4975 63.2049 25.754",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3092 33.9671C63.8295 34.878 64.1653 35.4923 65.1721 35.5469C67.2195 35.6575 70.8242 33.5593 71.6847 31.7328C72.0544 30.9493 71.8064 30.3752 70.9512 30.2646",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9925 26.9058C63.1846 25.841 62.5095 24.6828 61.9819 23.4564C61.0172 21.1879 60.4106 21.8109 60.9482 23.9648C61.0915 24.5395 61.2407 25.0363 61.3705 25.4569C61.7508 26.661 62.1152 27.8773 62.4598 29.093C62.8365 30.4309 64.1481 34.0554 65.1724 35.5497",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4611 24.7832C65.3938 25.4353 64.2267 26.4852 62.8818 28.1872",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M67.973 25.7451C67.2449 26.4761 66.6781 27.3499 66.3088 28.3109C65.9394 29.2719 65.7756 30.2989 65.8279 31.3264",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M103.739 34.3536C103.739 34.3536 105.14 31.7896 104.728 29.7787C104.239 27.3938 104.633 27.3443 105.828 29.425C106.621 30.8042 107.073 34.1105 107.073 34.1105",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M107.306 37.1833C107.306 37.1833 109.439 33.724 109.951 31.392C110.395 29.3695 109.629 30.2763 109.351 30.9267",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M107.544 29.7006C107.653 28.951 107.689 28.1925 107.65 27.4361C107.506 25.292 106.993 25.4351 106.65 27.2813C106.495 28.1478 106.287 29.0041 106.027 29.8454",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M107.14 29.2373C108.092 30.2508 108.696 31.5396 108.862 32.9171",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M107.65 28.5522C107.817 28.0868 107.973 27.5674 108.118 26.9938C108.627 24.9818 109.074 25.3913 108.974 27.2038C108.895 28.4768 108.666 29.7361 108.293 30.9563",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M108.863 28.5186C109.385 26.3303 109.909 26.684 109.763 28.6623C109.638 29.9889 109.312 31.2892 108.796 32.5189",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3174 81.5771L30.5841 83.1023",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3946 84.7939L27.8496 85.0702",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8291 84.0195L32.2842 84.2848",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3615 87.5118L31.0947 85.9756",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2814 84.2851C31.9955 84.3376 31.7003 84.3037 31.4339 84.1878C31.1675 84.0718 30.9421 83.8792 30.7868 83.6348C30.6835 83.4726 30.6135 83.2917 30.5809 83.1025C30.6159 83.2914 30.6129 83.4852 30.5719 83.6729C30.5309 83.8605 30.4528 84.0382 30.3421 84.1955C30.2315 84.3529 30.0904 84.4867 29.9273 84.5894C29.7641 84.6921 29.582 84.7614 29.3916 84.7935C29.5815 84.7594 29.7762 84.7628 29.9647 84.8036C30.1533 84.8444 30.3318 84.9218 30.4902 85.0314C30.6485 85.1413 30.7833 85.2814 30.8867 85.4436C30.99 85.6058 31.0599 85.7868 31.0922 85.9761C31.0571 85.7872 31.0602 85.5934 31.1012 85.4057C31.1421 85.2181 31.2202 85.0405 31.3309 84.8831C31.4416 84.7258 31.5826 84.5919 31.7458 84.4892C31.909 84.3865 32.091 84.3172 32.2814 84.2851Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5234 16.0078L52.7124 17.0799",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8682 18.2734L50.79 18.4613",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0017 17.7324L53.9131 17.9203",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2573 20.1964L53.0684 19.1133",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9133 17.92C53.779 17.9437 53.6412 17.9407 53.5081 17.9112C53.3749 17.8817 53.249 17.8264 53.1374 17.7483C53.0258 17.6702 52.9309 17.571 52.858 17.4563C52.7852 17.3417 52.7359 17.2138 52.7129 17.0801C52.7368 17.2138 52.7339 17.3508 52.7044 17.4834C52.6748 17.616 52.6192 17.7414 52.5407 17.8526C52.4622 17.9637 52.3623 18.0582 52.2469 18.1308C52.1315 18.2034 52.0028 18.2525 51.8682 18.2754C52.0025 18.2518 52.1402 18.2548 52.2733 18.2843C52.4065 18.3138 52.5325 18.3691 52.644 18.4472C52.7556 18.5252 52.8505 18.6245 52.9234 18.7391C52.9962 18.8538 53.0456 18.9817 53.0686 19.1154C53.0446 18.9817 53.0475 18.8446 53.0771 18.7121C53.1066 18.5795 53.1622 18.454 53.2408 18.3429C53.3193 18.2318 53.4191 18.1373 53.5345 18.0647C53.65 17.9921 53.7787 17.9429 53.9133 17.92Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M105.928 46.1348L106.406 48.8088",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M104.316 51.7715L101.627 52.2467",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M112.075 50.4121L109.385 50.8873",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M107.773 56.5125L107.295 53.8379",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M109.384 50.8874C109.051 50.9454 108.71 50.9377 108.38 50.8647C108.05 50.7918 107.738 50.6549 107.462 50.4619C107.185 50.269 106.949 50.0238 106.768 49.7403C106.587 49.4567 106.463 49.1405 106.405 48.8096C106.523 49.4778 106.369 50.1652 105.977 50.7206C105.585 51.276 104.987 51.654 104.315 51.7715C104.648 51.7135 104.989 51.7211 105.319 51.7941C105.649 51.8671 105.961 52.004 106.238 52.1969C106.514 52.3899 106.75 52.6351 106.931 52.9186C107.112 53.2021 107.236 53.5184 107.294 53.8493C107.177 53.181 107.331 52.4937 107.722 51.9383C108.114 51.3829 108.712 51.0049 109.384 50.8874Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0473 77.6217C95.1467 78.1202 95.095 78.6367 94.8988 79.1059C94.7026 79.5751 94.3707 79.9759 93.9452 80.2573C93.5199 80.5387 93.0202 80.6885 92.5093 80.6878C91.9984 80.687 91.4992 80.5359 91.0747 80.2533C90.7218 80.0181 90.4327 79.7 90.233 79.3271C90.0333 78.9543 89.9291 78.5383 89.9297 78.1159C89.9303 77.6935 90.0356 77.2777 90.2364 76.9054C90.4372 76.5332 90.7272 76.2159 91.0808 75.9817C91.4343 75.7475 91.8405 75.6036 92.2633 75.5628C92.6861 75.522 93.1126 75.5855 93.5048 75.7476C93.8971 75.9098 94.243 76.1657 94.5121 76.4926C94.7812 76.8195 94.965 77.2073 95.0473 77.6217Z",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3155 69.5812C67.336 71.7695 57.6706 72.9617 49.8803 73.6649C48.3224 73.8039 46.7622 73.4246 45.4445 72.5864C44.1269 71.7483 43.1264 70.4988 42.6001 69.0341C39.8975 61.4867 37.3908 54.1935 34.0312 42.853C35.2799 41.8235 36.7046 41.0259 38.2373 40.4983C39.5877 40.0386 40.9966 39.7709 42.4223 39.7031L51.1901 58.4468L72.1075 54.9567",
    fill: "url(#paint2_linear_412_373)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3155 69.5812C67.336 71.7695 57.6706 72.9617 49.8803 73.6649C48.3224 73.8039 46.7622 73.4246 45.4445 72.5864C44.1269 71.7483 43.1264 70.4988 42.6001 69.0341C39.8975 61.4867 37.3908 54.1935 34.0312 42.853C35.2799 41.8235 36.7046 41.0259 38.2373 40.4983C39.5877 40.0386 40.9966 39.7709 42.4223 39.7031L51.1901 58.4468L72.1075 54.9567",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0859 40.2334L47.0997 61.8617L39.0859 40.2334Z",
    fill: "url(#paint3_linear_412_373)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0859 40.2334L47.0997 61.8617",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0996 61.8623C47.4987 62.9349 48.2599 63.8363 49.2533 64.4127C50.2466 64.9892 51.4104 65.2047 52.5458 65.0226",
    fill: "url(#paint4_linear_412_373)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0996 61.8623C47.4987 62.9349 48.2599 63.8363 49.2533 64.4127C50.2466 64.9892 51.4104 65.2047 52.5458 65.0226",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5566 65.0219L75.3519 61.3311L52.5566 65.0219Z",
    fill: "url(#paint5_linear_412_373)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5566 65.0219L75.3519 61.3311",
    stroke: "black",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_412_373",
    x1: 72.0833,
    y1: 51.8311,
    x2: 72.0833,
    y2: 71.0545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB9BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_412_373",
    x1: 52.4278,
    y1: 60.96,
    x2: 52.4278,
    y2: 82.2596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB9BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_412_373",
    x1: 54.1734,
    y1: 39.7031,
    x2: 54.1734,
    y2: 73.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB9BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_412_373",
    x1: 43.0928,
    y1: 40.2334,
    x2: 43.0928,
    y2: 61.8617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB9BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_412_373",
    x1: 49.8227,
    y1: 61.8623,
    x2: 49.8227,
    y2: 65.0856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB9BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_412_373",
    x1: 63.9542,
    y1: 61.3311,
    x2: 63.9542,
    y2: 65.0219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB9BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CED1FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmittedFormDecorativeImage);
export default __webpack_public_path__ + "static/media/submitted-form-decorative-image.c6ce3006e0dec11a9cd552b6744f4b1b.svg";
export { ForwardRef as ReactComponent };